import {noop} from '@logistics-frontend/utils'
import React, {createContext, useContext} from 'react'

import {PromoBannerContext as Context, ProviderProps} from './PromoBanner.types'

const DEFAULT_CONTEXT: Context = {
  isPopupScreenVisible: false,
  onClosePopupScreen: noop,
  onOpenPopupScreen: noop,
}

const PromoBannerContext = createContext<Context>(DEFAULT_CONTEXT)

export const PromoBannerProvider: React.FC<ProviderProps> = ({data, children}) => (
  <PromoBannerContext.Provider value={data}>{children}</PromoBannerContext.Provider>
)

export const usePromoBannerContext = () => useContext(PromoBannerContext)
